module.exports = __webpack_public_path__ + "img/zhuanpan-zhizhen2-gray.6f4f54d8.png";